<template>
  <collapsible-section
      :id="id"
      control-name="elementsCollapse"
      :is-open="isOpen"
  >
    <template #section-header>
      Elements
    </template>

    <template #section-contents>
      <slot></slot>
    </template>
  </collapsible-section>
</template>

<script lang="ts">
import Vue from 'vue';
import CollapsibleSection from './common/collapsible-section.vue';

export default Vue.extend({
  components: {
    CollapsibleSection,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
});
</script>